module.exports = __webpack_public_path__ + "img/post3.61850674.png";